var $408efdba49f00d5d$exports = {};
$408efdba49f00d5d$exports = {
    "loading": `Laden...`,
    "loadingMore": `Meer laden...`
};


export {$408efdba49f00d5d$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
